import React, { useContext } from 'react';
import { AuthContext, TeamContextProvider } from 'contexts';
import Page from './Page';

const TeamSettingsPage: React.FC = () => {
  const { auth } = useContext(AuthContext);

  return (
    <>
      <TeamContextProvider auth={auth}>
        <Page />
      </TeamContextProvider>
    </>
  );
};

export default TeamSettingsPage;
